export const logInModalI18n = {
  title: {
    en: 'Welcome back',
  },
} as const;
